import { USER_ROLES } from 'cpool-constants';

// shared by route guards and navigation, mirrors the backend resolver grants
export const ROUTE_ROLES = {
    ADVISERS: [USER_ROLES.team_leader],
    LEAD_DISTRIBUTION: [USER_ROLES.admin, USER_ROLES.corporation_director, USER_ROLES.division_leader],
    LEAD_LIST: [
        USER_ROLES.accountant_manager,
        USER_ROLES.admin,
        USER_ROLES.adviser,
        USER_ROLES.corporation_director,
        USER_ROLES.division_leader,
        USER_ROLES.team_leader,
    ],
    USER_MANAGEMENT: [USER_ROLES.admin, USER_ROLES.corporation_director],
} as const;
